<template>
    <div class="cer_item_news" >
        <slot name="postNameLabel"></slot>
        <slot name="certCode"></slot>
        <slot name="issuingUnit"></slot>
        <slot name="effectiveDate"></slot>
        <div class="cer_btn" >
            <span @click="deleteCre" style="color:rgb(178, 31, 39)">删除</span>
        </div>
        <el-dialog
            title=""
            :visible.sync="visible"
            center>

        </el-dialog>
    </div>
</template>
<script>
import { deleteCers } from "@/api/personal"
import { PcCookie, Key } from "@/utils/cookie";
import VueEvent from '@/VueEvent.js'
export default {
    name: "PersonalCerficateItem",
    props: {
        //证书
        cerItem:{
            type:Object,
            default(){
                return {}
            }
        }
    },
    data() {
        return {
            visible: false,
            sessionId:PcCookie.get(Key.jsessIdKey),
        };
    },
    created() {},
    methods: {
        //修改证书
        deleteCre(){
            this.$confirm('确定要删除该证件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(async() => {
                let res = await deleteCers(this.sessionId,this.cerItem.id)
                if(res.success){
                    this.$message({
                        type: 'success',
                        message: `删除成功`
                    });
                    VueEvent.$emit('refreshCerTable');
                }else{
                    this.$message.error('删除失败');
                }
            }).catch(() => {
                console.log('用户点击了取消按钮'); // 在这里处理用户点击取消的情况
            });
        }
    },
};
</script>
<style scoped>
.certPathImg{
    max-width: 100%;
}
.cer_btn{
    width: 60px;
    color: #606266;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size:13px;
}
.cer_item_news_text{
    width: 208px;
    font-size: 14px;
    color: #606266;
    display: flex;
    align-items: center;
    justify-content: center;
}
.cer_item_news{
    padding: 8px 15px;
    display: flex;
    flex-direction: row;
    width: 100%;
    border: solid 1px #e2e2e2;
}
</style>
